import { navigateAction } from 'fluxible-router';
import { resolveContext } from '../../services/context-provider';

type TMFAError =
  | 'UserNonVerifiedPhone_UserNeedsToInsertMFAConfirmationCodeError'
  | 'UserVerifiedPhone_UserNeedsToInsertMFAConfirmationCodeError'
  | 'UserNonVerifiedPhone_UserNeedsToSendConfirmationCodeError'
  | 'UserVerifiedPhone_UserNeedsToSendConfirmationCodeError'
  | 'SpotMFACodeSender_ModeratorPhoneIsAlreadyVerifiedError'
  | 'SpotMFACode_UserNeedsToEnterConfirmationCode';

const mfaInterceptor = async ({
  type,
  spotId
}: {
  type: TMFAError;
  spotId: string;
}): Promise<void> => {
  switch (type) {
    case 'UserVerifiedPhone_UserNeedsToInsertMFAConfirmationCodeError':
    case 'SpotMFACodeSender_ModeratorPhoneIsAlreadyVerifiedError':
    case 'UserVerifiedPhone_UserNeedsToSendConfirmationCodeError':
    case 'UserNonVerifiedPhone_UserNeedsToInsertMFAConfirmationCodeError':
    case 'SpotMFACode_UserNeedsToEnterConfirmationCode':
      resolveContext().then(context => {
        context.executeAction(navigateAction, {
          url: `/spot/${spotId}/two-factor-authentication`
        });
      });
      break;
    case 'UserNonVerifiedPhone_UserNeedsToSendConfirmationCodeError':
    case 'SpotMFACode_UserNeedsToEnterConfirmationCode':
      resolveContext().then(context => {
        context.executeAction(navigateAction, {
          url: `/spot/${spotId}/two-factor-authentication`
        });
      });
      break;
    default:
      return;
  }
};

export default mfaInterceptor;
